import { createReducer, createAction, PayloadAction } from '@reduxjs/toolkit'
import { TimeSlot } from '../types'
export interface TimeSlotsReducer {
  selectedDay: {
    day: string
    year: number
    month: number
  }
  timeSlots: TimeSlot[]
  lastFetchedAt: string
}

const initialState: TimeSlotsReducer = {
  selectedDay: {
    day: '',
    year: 0,
    month: 0
  },
  timeSlots: [],
  lastFetchedAt: ''
}

interface SetSelectedDayPayload {
  day: string
  year: number
  month: number
}

export const SET_SELECTED_DAY = createAction<SetSelectedDayPayload>('time_slots_reducer/set_current_day')

export const FETCH_TIME_SLOTS = createAction('time_slots_reducer/fetch_time_slots')
export const FETCH_TIME_SLOTS_SUCCESS = createAction<TimeSlot[]>('time_slots_reducer/fetch_time_slots_success')
export const FETCH_TIME_SLOTS_FAIL = createAction('time_slots_reducer/fetch_time_slots_failed')

interface CreateTimeSlotPayload {
  start_time: number
  is_available: boolean
}
export type CreateTimeSlotActionType = PayloadAction<CreateTimeSlotPayload>
export const CREATE_TIME_SLOT = createAction<CreateTimeSlotPayload>('time_slots_reducer/create_time_slot')
export const CREATE_TIME_SLOT_SUCCESS = createAction<TimeSlot>('time_slots_reducer/create_time_slot_success')
export const CREATE_TIME_SLOT_FAIL = createAction('time_slots_reducer/create_time_slot_failed')

export const timeSlotsReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(SET_SELECTED_DAY, (state, { payload }) => {
      return { ...state, selectedDay: { ...payload } }
    })
    .addCase(FETCH_TIME_SLOTS_SUCCESS, (state, { payload }) => {
      return { ...state, timeSlots: payload, lastFetchedAt: new Date().toISOString() }
    })
    .addCase(CREATE_TIME_SLOT_SUCCESS, (state, { payload }) => {
      const existingIndex = state.timeSlots.findIndex((slot) => slot.id === payload.id)
      if (existingIndex !== -1) {
        return { ...state, timeSlots: state.timeSlots.map((slot, index) => (index === existingIndex ? payload : slot)) }
      } else {
        return { ...state, timeSlots: [...state.timeSlots, payload] }
      }
    })
})
